﻿/*!
    *
    * Wijmo Library 5.20251.34
    * https://developer.mescius.com/wijmo
    *
    * Copyright(c) MESCIUS inc. All rights reserved.
    *
    * Licensed under the End-User License Agreement For MESCIUS Wijmo Software.
    * us.sales@mescius.com
    * https://developer.mescius.com/wijmo/licensing
    *
    */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { VueApi, WjComponentBehavior } from '@mescius/wijmo.vue2.base';
import * as wjcGridGrouppanel from '@mescius/wijmo.grid.grouppanel';
var WjGroupPanelBehavior = /** @class */ (function (_super) {
    __extends(WjGroupPanelBehavior, _super);
    function WjGroupPanelBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjGroupPanelBehavior.tag = 'wj-group-panel';
    WjGroupPanelBehavior.props = [
        'isDisabled',
        'tabOrder',
        'hideGroupedColumns',
        'showDragGlyphs',
        'maxGroups',
        'placeholder',
        'filter',
        'groupDescriptionCreator',
        'grid'
    ];
    WjGroupPanelBehavior.events = [
        'initialized',
        'gotFocus',
        'lostFocus',
        'refreshing',
        'refreshed',
        'invalidInput'
    ];
    WjGroupPanelBehavior.classCtor = function () { return wjcGridGrouppanel.GroupPanel; };
    return WjGroupPanelBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.grid.grouppanel.GroupPanel} control.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.grid.grouppanel.GroupPanel} control it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 *
 * The example below shows how to instantiate and connect a
 * {@link wijmo.grid.grouppanel.GroupPanel} and a {@link wijmo.grid.FlexGrid}
 * in Vue:
 *
 * <pre>&lt;wj-group-panel
 *   id="thePanel"
 *   placeholder="Drag columns here to create Groups"&gt;
 * &lt;/wj-group-panel&gt;
 * &lt;wj-flex-grid
 *   id="theGrid"
 *   :items-source="data"&gt;
 * &lt;/wj-flex-grid&gt;</pre>
 *
 * <pre>var app = new Vue({
 *   el: '#app',
 *   // connect group panel and grid
 *   mounted: function () {
 *     var panel = wijmo.Control.getControl(document.getElementById('thePanel'));
 *     var grid = wijmo.Control.getControl(document.getElementById('theGrid'));
 *     panel.grid = grid;
 *   }
 * });</pre>
 */
export var WjGroupPanel = WjGroupPanelBehavior.register();
function registerV3WjGroupPanel(app) {
    app.component(WjGroupPanelBehavior.tag, WjGroupPanel);
}
export function registerGridGrouppanel(app) {
    if (VueApi.isV3Plus) {
        registerV3WjGroupPanel(app);
    }
}
